import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const macOptionSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28" fill="none">
        <path stroke="currentColor" d="M22 17.5h-5.5l-5-7H6m16 0h-6"></path>
    </svg>
)

const MacOption: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {macOptionSvg}
    </SvgIcon>
)

export default MacOption